module.exports = __webpack_public_path__ + "img/xcx.1e10929b.jpg";